import { z } from 'zod';
import { ContactPersonSchema } from './contact';
import { TravelerSchema } from './traveler';

/**
 * Invoice Recipient Enum
 * Determines who will receive the invoice
 * - solo: Contact person is traveling and receives invoice
 * - accompany: Contact person is not traveling, only receives invoice
 */
export const InvoiceRecipientEnum = z.enum(['solo', 'accompany']);
export type InvoiceRecipient = z.infer<typeof InvoiceRecipientEnum>;

/**
 * Complete Checkout Form Data Schema
 * Combines all sections of the checkout Step 2 form
 */
export const CheckoutFormDataSchema = z.object({
  contactPerson: ContactPersonSchema,
  invoiceRecipient: InvoiceRecipientEnum,
  travelers: z.array(TravelerSchema),
});

export type CheckoutFormData = z.infer<typeof CheckoutFormDataSchema>;

/**
 * Re-export all schemas and types for convenient access
 */
export * from './validation';
export * from './contact';
export * from './traveler';
export * from './terms';
export * from './discount';
export * from './addressValidation';
